import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import ExpandView from '@/components/generals/expand-view'

interface MockupFigureProps {
    label: string
    title: string
    caption?: string
    children: ReactNode
    expanded?: ReactNode
    ratio?: number
    className?: string
    stageClassName?: string
}

// An illustration stage with an accessible description, an optional caption bar
// and a button that opens the same illustration at a larger size.
const MockupFigure: FC<MockupFigureProps> = ({
    label,
    title,
    caption,
    children,
    expanded,
    ratio,
    className,
    stageClassName
}): ReactNode => {
    return (
        <figure className={cn('relative flex flex-col overflow-hidden', className)}>
            <div className={cn('relative flex-1 bg-stage px-[8%] pb-[11%] pt-[8%]', stageClassName)}>
                <div role='img' aria-label={label}>
                    {children}
                </div>

                <ExpandView
                    title={title}
                    caption={caption}
                    ratio={ratio}
                    className='absolute bottom-3 right-3'
                >
                    {expanded ?? children}
                </ExpandView>
            </div>

            {caption && (
                <figcaption className='border-t border-border px-5 py-3 font-mono text-[0.62rem] font-semibold uppercase tracking-[0.14em] text-muted-foreground'>
                    {caption}
                </figcaption>
            )}
        </figure>
    )
}

export default MockupFigure
